export default "__VITE_ASSET__D2RL3TPq__"